export default "__VITE_ASSET___C4Zmh3t__"